import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "frisbuy-similar-title"
}

import { ref, watch } from 'vue';
import GalleryBlur from "@/components/popup/GalleryBlur.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'productImage',
  props: {
    thumbUrl: {},
    isSimilar: { type: Boolean },
    similarGood: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const photo = ref<HTMLDivElement | null>(null);
const contentIsLoaded = ref<boolean>(false);

watch(
    () => props.thumbUrl,
    (newThumbUrl) => {
        contentIsLoaded.value = false;

        const image = new Image();
        const loaded = () => {
            const { src: imageSource } = image;

            contentIsLoaded.value = true;
            if (!photo.value) return;

            (photo.value as HTMLDivElement).style.backgroundImage = `url(${imageSource})`;
        };

        const onError = () => {
            contentIsLoaded.value = true;
        };

        image.addEventListener("load", loaded);
        image.addEventListener("load", onError);

        if (newThumbUrl) {
            image.src = newThumbUrl;
        }
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "photo",
    ref: photo,
    class: "frisbuy-product-image"
  }, [
    (!contentIsLoaded.value)
      ? (_openBlock(), _createBlock(GalleryBlur, { key: 0 }))
      : _createCommentVNode("", true),
    (props.isSimilar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.similarGood), 1))
      : _createCommentVNode("", true)
  ], 512))
}
}

})